import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { FileDown } from "lucide-react";
import { Wizard, Progress } from "../components/connect/Wizard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SetupShared() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { axios.get(`${API}/connect/shared/${token}`).then((r) => setD(r.data)).catch((e) => setErr(e.response?.data?.detail || "This link isn't valid")); }, [token]);
  return (
    <div className="min-h-screen bg-[#05050a] text-white px-4 py-10" data-testid="setup-shared-page">
      <div className="max-w-4xl mx-auto space-y-6">
        <div>
          <p className="font-mono text-[11px] tracking-widest text-brand">AEGIS · DEVELOPER SETUP GUIDE</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold mt-2">{d ? d.values.merchant : "Setup guide"}</h1>
        </div>
        {err && <p className="panel p-5 text-red-300" data-testid="setup-shared-error">{err}</p>}
        {d && <>
          <div className="panel p-5 space-y-3">
            <p className="text-sm text-white/70">Read-only. The merchant enters their Whop key and signing secret inside AEGIS; this page never shows secrets. Production address: <code className="text-brand">{d.values.base_url}</code>. Link expires {new Date(d.expires_at).toLocaleDateString()}.</p>
            <Progress done={d.done} total={d.total} />
            <a href={`${API}/connect/shared/${token}/pdf`} className="inline-flex items-center gap-2 font-mono text-[11px] text-brand hover:underline" data-testid="setup-shared-pdf"><FileDown className="w-3 h-3" /> Download PDF</a>
          </div>
          <Wizard d={d} edit={false} setD={setD} reload={() => {}} />
        </>}
      </div>
    </div>
  );
}
